import React from 'react';
import BudgetHeader from './BudgetHeader';
import ClientSection from './ClientSection';
import ProductCard from './ProductCard';
import AdvantagesCard from './AdvantagesCard';
import ExcludedItemsCard from './ExcludedItemsCard';
import PaymentCard from './PaymentCard';
import TotalsCard from './TotalsCard';
import ObservationCard from './ObservationCard';
import SignatureCard from './SignatureCard';
import Footer from './Footer';
import { COLORS, SIZES, FONT_URL } from './design-tokens';

const ProductsSection = ({ products }) => {
  return (
    <div
      style={{
        background: COLORS.card,
        border: `1px solid ${COLORS.line}`,
        borderRadius: '10px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        width: SIZES.leftColumnWidth,
        boxSizing: 'border-box'
      }}
    >
      <div
        style={{
          background: COLORS.primary,
          color: COLORS.card,
          padding: '3mm 4mm',
          fontSize: '14px',
          fontWeight: 700,
          letterSpacing: '1px',
          display: 'flex',
          alignItems: 'center',
          gap: '2mm',
          flexShrink: 0
        }}
      >
        <span>DESCRIÇÃO DOS PRODUTOS</span>
      </div>
      <div style={{ padding: '3mm', display: 'flex', flexDirection: 'column', gap: '2mm' }}>
        {products.map((p, i) => (
          <ProductCard key={p.id || i} product={p} index={i} />
        ))}
      </div>
    </div>
  );
};

const BudgetTemplate = ({ budget }) => {
  const { company, customer, project, products, payment, totals, observations, advantages, excludedItems } = budget;

  return (
    <>
      <link rel="stylesheet" href={FONT_URL} />
      <div
        style={{
          width: SIZES.pageWidth,
          height: SIZES.pageHeight,
          padding: SIZES.margin,
          background: COLORS.backgroundMain,
          fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
          boxSizing: 'border-box',
          color: COLORS.textPrimary,
          position: 'relative',
          overflow: 'hidden',
          wordBreak: 'normal',
          overflowWrap: 'break-word',
          display: 'grid',
          gridTemplateRows: 'auto auto 1fr auto',
          rowGap: '5mm'
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <BudgetHeader company={company} project={project} />
          <ClientSection customer={customer} />
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `${SIZES.leftColumnWidth} ${SIZES.rightColumnWidth}`,
            columnGap: SIZES.columnGap,
            alignItems: 'flex-start',
            width: SIZES.pageContentWidth
          }}
        >
          <ProductsSection products={products || []} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '3mm',
              width: SIZES.rightColumnWidth,
              flexShrink: 0
            }}
          >
            <AdvantagesCard advantages={advantages} />
            <ExcludedItemsCard items={excludedItems} />
            <PaymentCard payment={payment} />
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '5mm',
            width: SIZES.pageContentWidth
          }}
        >
          <TotalsCard company={company} totals={totals} />
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: `${SIZES.leftColumnWidth} ${SIZES.rightColumnWidth}`,
              columnGap: SIZES.columnGap,
              alignItems: 'flex-start',
              width: SIZES.pageContentWidth
            }}
          >
            <ObservationCard observations={observations} />
            <SignatureCard />
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default BudgetTemplate;
